import type { Turno } from "../types/turno";
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useTurnos() {
  const store = useStore(key);
  let lstTurnos: Ref<Turno[]> = ref([]);

  async function getTurnos(empresa: string) {
    try {
      await axios
        .get(store.state.url + "api/Turno/GetTurnos?company=" + empresa, {
          headers: {},
        })
        .then((response) => {
          if (response.status == 200) {
            lstTurnos.value = response.data as Turno[];
            // console.log(lstTurnos.value);
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return { getTurnos, lstTurnos };
}
